<template>
  <div>
    <div class="search-box btn3" :class="{ close: !searchMore }">
      <div class="input-item">
        <span class="label">保单号</span>
        <Input type="text" v-model="searchParams.policyNo" clearable placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">批单号</span>
        <Input type="text" v-model="searchParams.billNo" clearable placeholder="请输入" />
      </div>

      <div class="input-item">
        <span class="label">保险公司</span>
        <Select v-model="searchParams.companyCode" placeholder="请选择" filterable clearable transfer>
          <Option v-for="(bean, i) in companyList" :key="i" :value="bean.code">{{ bean.name }}</Option>
        </Select>
      </div>

      <div class="input-item select-two">
        <Select v-model="dateType" :transfer="true">
          <Option value="1">投保日期</Option>
          <Option value="5">支付日期</Option>
          <Option value="2">承保日期</Option>
          <Option value="3">生效日期</Option>
          <Option value="4">退保日期</Option>
        </Select>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>

      <div class="input-item">
        <span class="label">保单状态</span>
        <Select v-model="searchParams.policyStatusList" clearable transfer multiple>
          <Option value="1">已承保</Option>
          <Option value="-1">已退保</Option>
          <Option value="0">已终止</Option>
        </Select>
      </div>

      <div class="input-item" v-if="userInfo.userType == 3">
        <span class="label">结算周期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
          :disabled="searchParams.settlementTimeNull && searchParams.settlementTimeNull.length ? true : false"
        ></DatePicker>
        <CheckboxGroup v-model="searchParams.settlementTimeNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'settlementDate')">
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <!-- <div class="input-item" v-if="userInfo.userType ==3">
        <span class="label">所属结算单</span>
        <Select v-model="searchParams.reportId" clearable transfer filterable>
          <Option :value="item.id" v-for="(item, index) in settlementDocList" :key="index">{{ item.reportName }}</Option>
        </Select>
      </div> -->

      <div class="input-item">
        <span class="label">产品名称</span>
        <Select v-model="searchParams.productCode" clearable transfer filterable>
          <Option :value="item.productCode" v-for="(item, index) in productList" :key="index">{{ item.productCode }}/{{ item.productName }}</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">险种分类</span>
        <Select v-model="searchParams.themeIds" clearable transfer filterable multiple>
          <Option :value="item.themeId" v-for="(item, index) in productThemeList" :key="index">{{ item.title }}</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">业务类别</span>
        <Select
          v-model="searchParams.sellType"
          placeholder="请选择"
          multiple
          :disabled="searchParams.sellTypeStatusNull && searchParams.sellTypeStatusNull.length ? true : false"
        >
          <Option value="1">网销产品</Option>
          <Option value="3">经代产品</Option>
        </Select>
        <CheckboxGroup v-model="searchParams.sellTypeStatusNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'sellType')">
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item">
        <span class="label">保/批单</span>
        <Select v-model="searchParams.isBill" clearable transfer filterable>
          <Option value="0">保单</Option>
          <Option value="1">批单</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">结算状态</span>
        <Select v-model="searchParams.settlementStatus" transfer placeholder="请选择" clearable>
          <Option value="1">已结算</Option>
          <Option value="0">待结算</Option>
        </Select>
      </div>

      <div class="input-item" v-if="userInfo.userType != 3">
        <span class="label">所属结算报表</span>
        <Select
          v-model="searchParams.settlementReportId"
          clearable
          transfer
          filterable
          :disabled="searchParams.settlementReportNull && searchParams.settlementReportNull.length ? true : false"
        >
          <Option :value="item.id" v-for="(item, index) in settlementList" :key="index">{{ item.reportName }}</Option>
        </Select>
        <CheckboxGroup
          v-model="searchParams.settlementReportNull"
          style="margin-left: 10px; width: 100px"
          @on-change="changeTimeNull($event, 'settlementReportId')"
        >
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item" v-if="userInfo.userType != 3">
        <span class="label">发布状态</span>
        <Select v-model="searchParams.releaseStatus" transfer placeholder="请选择" clearable>
          <Option value="1">已发布</Option>
          <Option value="0">未发布</Option>
        </Select>
      </div>

      <div class="input-item" v-if="userInfo.userType != 3">
        <span class="label">结算周期</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.settlementDate"
          @on-change="searchParams.settlementDate = $event"
          :disabled="searchParams.settlementTimeNull && searchParams.settlementTimeNull.length ? true : false"
        ></DatePicker>
        <CheckboxGroup v-model="searchParams.settlementTimeNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'settlementDate')">
          <Checkbox label="1">为空</Checkbox>
        </CheckboxGroup>
      </div>

      <div class="input-item" v-if="userInfo.userType != 3">
        <span class="label">所属结算单</span>
        <Select v-model="searchParams.reportId" clearable transfer filterable>
          <Option :value="item.id" v-for="(item, index) in settlementDocList" :key="index">{{ item.reportName }}</Option>
        </Select>
      </div>

      <div class="input-item">
        <span class="label">出单机构</span>
        <selectTree v-model="searchParams.orgIds" type="4" :maxTagCount="1" :multiple="true" ref="selectTreeRef"> </selectTree>
      </div>

      <div class="input-item">
        <span class="label">出单业务员</span>
        <lzSelect v-model="searchParams.salesmanId" placeholder="请输入姓名或工号搜索" :remote-method="getUserList">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
            </Option>
          </template>
        </lzSelect>
      </div>

      <div class="input-item">
        <span class="label">费用归属</span>
        <lzSelect v-model="searchParams.owerId" placeholder="请输入姓名或工号搜索" :remote-method="getUserList">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
            </Option>
          </template>
        </lzSelect>
      </div>
      <div class="input-item" v-if="$units.isOkBao() || $units.isRYBB()">
        <span class="label">团险销售支持</span>
        <Select v-model="searchParams.groupSalesSupportId" clearable filterable>
          <Option v-for="(item, i) in groupSalesSupportList" :key="i" :value="item.id" :label="item.name"></Option>
        </Select>
      </div>

      <div class="input-item">
        <span slot="label" class="label">
          是否已打款<span class="tip-icon">?</span>
          <div class="pop-tip">
            <span>业务员提现审核通过后将标记为已打款</span>
            <div class="arrow"></div>
          </div>
        </span>
        <Select v-model="searchParams.paymentStatus" clearable transfer filterable>
          <Option value="1">已打款</Option>
          <Option value="0">未打款</Option>
        </Select>
      </div>

      <div class="input-item">
        <span slot="label" class="label">
          是否扣款记录<span class="tip-icon">?</span>
          <div class="pop-tip">
            <span>因退保等原因已扣除费用的记录</span>
            <div class="arrow"></div>
          </div>
        </span>
        <RadioGroup v-model="searchParams.isDeduct" @on-change="searchAjax">
          <Radio label="">全部</Radio>
          <Radio label="1">是</Radio>
          <Radio label="0">否</Radio>
        </RadioGroup>
      </div>

      <div class="input-item">
        <span class="label">费用类型</span>
        <Select v-model="searchParams.commissionStyles" clearable transfer multiple>
          <Option value="1">基础费用</Option>
          <Option value="2">团队长基础管理费</Option>
          <Option value="3">限时加费</Option>
        </Select>
      </div>

      <div class="input-item" v-if="userInfo.userType != 3">
        <span class="label">长短险标志</span>
        <Select v-model="searchParams.productType" clearable transfer>
          <Option value="1">长险</Option>
          <Option value="2">短险</Option>
        </Select>
      </div>

      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
        <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
          >收起
          <Icon type="ios-arrow-up" />
        </Button>
        <Button type="primary" ghost v-else @click="searchMore = true"
          >展开
          <Icon type="ios-arrow-down" />
        </Button>
      </div>
    </div>

    <div class="tools-box">
      <div class="statistics-container">
        <div class="statistics-item">
          <span class="dot"></span>
          <span>保单：</span>
          <span class="num">{{ statisticsData.policyNum }}</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>批单：</span>
          <span class="num">{{ statisticsData.billNum }}</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>保费：</span>
          <span class="num">{{ statisticsData.fee }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>费用合计：</span>
          <span class="num">{{ statisticsData.commissionPrice }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>已结算费用：</span>
          <span class="num">{{ statisticsData.settlementCommissionPrice }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>未结算费用：</span>
          <span class="num">{{ statisticsData.noSettlementCommissionPrice }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>已打款费用：</span>
          <span class="num">{{ statisticsData.paymentCommissionPrice }}元</span>
        </div>

        <div class="statistics-item">
          <span class="dot"></span>
          <span>未打款费用：</span>
          <span class="num">{{ statisticsData.noPaymentCommissionPrice }}元</span>
        </div>
      </div>

      <Button type="primary" ghost @click="exportExcel">导出</Button>
    </div>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="settlementStatus">
          <div class="settlement-status">
            <span v-if="row.settlementStatus == 0" class="tag-settled">待结算</span>
            <span v-else class="tag-be">已结算</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="releaseStatus">
          <div class="release-status">
            <span v-if="row.releaseStatus == '0'" class="tag-settled">未发布</span>
            <span v-else-if="row.releaseStatus == '1'" class="tag-be">已发布</span>
            <span v-else>-</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="overName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.owerWorkingState == 0, orange: row.owerIsSus == 1 }" v-if="row.owerName"></i>
              <span class="user-name">{{ row.owerStaffNo }}</span>
              <span v-if="row.owerStaffNo">/</span>
              <span class="user-name">{{ row.owerName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="salesmanName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.salesWorkingState == 0, orange: row.salesIsSus == 1 }" v-if="row.salesmanName"></i>
              <span class="user-name">{{ row.salesmanStaffNo }}</span>
              <span v-if="row.salesmanStaffNo">/</span>
              <span class="user-name">{{ row.salesmanName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" v-if="row.isDeduct == 1 && row.settlementStatus == 0 && !row.billNo" @click="$refs.commissionModify.open(row, true)"
            >修改</span
          >
          <span v-else-if="row.isDeduct == 1 && row.settlementStatus == 1 && !row.billNo" class="disabled-btn">修改</span>

          <span class="table-btn" @click="withholdingCommission(row)" v-else-if="row.canDeduct == 1 && !row.billNo">扣款</span>
          <span v-else>-</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>

    <commission-modify ref="commissionModify" @success="searchAjax" policyType="group"></commission-modify>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
import selectTree from '@/components/system/selectTree3';
import commissionModify from './components/commissionModify';
import lzSelect from '@/components/commons/lzSelect';
import { treeFlatArr } from '@/api/filter';

export default {
  mixins: [pageTool, common],
  components: {
    selectTree,
    lzSelect,
    commissionModify
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      tabVal: '1',
      dateType: '1',
      searchParams: {
        sellType: []
      },
      settlementDocList: [],
      statisticsData: {},
      settlementList: [],
      supplierList: [],
      companyList: [],
      productList: [],
      productThemeList: [],
      tableData: [],
      salesSupportList: [], //个险销售支持
      groupSalesSupportList: [], //团险销售支持
      columns: [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 160,
          fixed: 'left'
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180,
          fixed: 'left',
          render(h, params) {
            let billNo = params.row.billNo;
            return <span>{billNo ? billNo : '-'}</span>;
          }
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 120,
          slot: 'settlementStatus'
        },
        {
          title: '所属结算报表',
          align: 'center',
          key: 'settlementReportName',
          minWidth: 180
        },
        {
          title: '结算周期',
          align: 'center',
          minWidth: 220,
          render(h, params) {
            let settlementDate = params.row.settlementDate;
            return <span>{filter.filterTime(settlementDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '所属结算单/结算周期',
          align: 'center',
          key: 'reportName',
          minWidth: 180,
          render(h, params) {
            let reportName = params.row.reportName;
            let settlementDate = params.row.settlementDate;
            return (
              <div>
                <span>{reportName}</span>
                <span>{reportName && settlementDate ? '/' : ''}</span>
                <span>{settlementDate ? filter.filterTime(settlementDate, 'YYYY-MM-DD') : ''}</span>
              </div>
            );
          }
        },
        {
          title: '发布状态',
          align: 'center',
          minWidth: 180,
          slot: 'releaseStatus',
          renderHeader: (h, params) => {
            return (
              <div>
                <span>发布状态</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                  <div slot="content">
                    <p>发布后业务员即可在APP上查看到此条记录</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
        {
          title: '是否已打款',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let paymentStatus = params.row.paymentStatus;
            return <span>{paymentStatus == 0 ? '未打款' : '已打款'}</span>;
          },
          renderHeader: (h, params) => {
            return (
              <div>
                <span>是否已打款</span>
                <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip" transfer={true}>
                  <Icon style="color:#A8ADB7;margin-left:4px;" type="md-help-circle" />
                  <div slot="content">
                    <p>业务员提现审核通过后将标记为已打款</p>
                  </div>
                </Poptip>
              </div>
            );
          }
        },
        {
          title: '打款日期',
          align: 'center',
          key: 'paymentDate',
          minWidth: 120,
          render(h, params) {
            let paymentDate = params.row.paymentDate;
            return <span>{paymentDate ? filter.filterTime(paymentDate, 'YYYY-MM-DD') : ''}</span>;
          }
        },
        {
          title: '供应商',
          minWidth: 100,
          align: 'center',
          key: 'supplierName',
          render(h, params) {
            let supplierName = params.row.supplierName;
            return <span>{supplierName ? supplierName : '-'}</span>;
          }
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '长短险标志',
          minWidth: 110,
          align: 'center',
          render(h, params) {
            if (params.row.productType == '1') {
              return <span>长险</span>;
            } else if (params.row.productType == '2') {
              return <span>短险</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '险种分类',
          align: 'center',
          key: 'themeName',
          minWidth: 120
        },
        {
          title: '最新状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.policyStatus == '1') {
              return <span>已承保</span>;
            } else if (params.row.policyStatus == '0') {
              return <span>已终止</span>;
            } else if (params.row.policyStatus == '2') {
              return <span>续保</span>;
            } else if (params.row.policyStatus == '-1') {
              return <span>已退保</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '业务类别',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let sellType = params.row.sellType && JSON.parse(params.row.sellType);
            if (sellType.includes('1')) {
              return <span>网销产品</span>;
            } else if (sellType.includes('3')) {
              return <span>经代产品</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用归属',
          align: 'center',
          minWidth: 160,
          slot: 'overName_staffNo'
        },
        {
          title: '出单人',
          align: 'center',
          minWidth: 160,
          slot: 'salesmanName_staffNo'
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'owerType ',
          minWidth: 160,
          render(h, params) {
            const owerType = params.row.owerType;
            const commissionType = params.row.commissionType;
            if (owerType == 2 && (commissionType == 1 || commissionType == 3 || commissionType == 7 || commissionType == 9)) {
              return <span>团队长基础管理费</span>;
            } else if (owerType == 3 && (commissionType == 1 || commissionType == 3 || commissionType == 7 || commissionType == 9)) {
              return <span>基础费用</span>;
            } else if ((commissionType == 5 || commissionType == 21) && owerType == 3) {
              return <span>后置费用</span>;
            } else if ((commissionType == 5 || commissionType == 21) && owerType == 2) {
              return <span>后置费用管理费</span>;
            } else if (commissionType == 2 || commissionType == 4 || commissionType == 20 || commissionType == 8 || commissionType == 10) {
              return <span>限时加费</span>;
            }
          }
        },
        {
          title: '投保人',
          align: 'center',
          key: 'holderName',
          minWidth: 120
        },
        {
          title: '费率',
          align: 'center',
          key: 'commission',
          minWidth: 120,
          render(h, params) {
            const commission = params.row.commission;
            return <span>{commission ? commission + '%' : '-'}</span>;
          }
        },
        {
          title: '费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 150,
          render(h, params) {
            const commissionPrice = params.row.commissionPrice;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            } else if (deductType == 4) {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{commissionPrice ? commissionPrice : '-'}</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Poptip>
                </div>
              );
            } else {
              return <span>{commissionPrice ? commissionPrice : '-'}</span>;
            }
          }
        },
        {
          title: '出单团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '出单机构',
          align: 'center',
          key: 'orgName',
          minWidth: 150
        },
        // {
        //   title: '个险销售支持',
        //   align: 'center',
        //   key: 'salesSupportName',
        //   minWidth: 100
        // },
        {
          title: '团险销售支持',
          align: 'center',
          key: 'groupSalesSupportName',
          minWidth: 140
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 120,
          fixed: 'right'
        }
      ]
    };
  },

  activated() {
    if (this.userInfo.userType == 3) {
      this.columns = this.columns.filter(item => item.title != '所属结算报表' && item.title != '发布状态' && item.title != '操作' && item.title != '供应商' && item.title != '长短险标志' && item.title != '险种分类' && item.title != '业务类别' && item.title != '所属结算单/结算周期');
    } else {
      this.columns = this.columns.filter(item => item.title != '结算周期');
    }
    if (!this.$units.isOkBao() && !this.$units.isRYBB()) {
      this.columns = this.columns.filter(item => item.title != '销售支持' && item.title != '团险销售支持');
    } else {
      this.getOkBaoSalesSupport();
    }
    this.getList();
    this.getBaosi();
    this.queryProduct();
    this.getProductTheme();
    this.getSettlementList();
    this.getSettlementDocList();
    this.getStatistics();
  },

  methods: {
    searchAjax() {
      this.pageNum = 1;
      this.getList();
      this.getStatistics();
    },
    // 重置
    resetSearch() {
      this.searchParams = {
        sellType: []
      };
      this.dateType = '1';
      this.searchAjax();
    },
    // 获取个险、团险销售支持
    getOkBaoSalesSupport() {
      this.$http({
        url: '/buz/userBase/okbao/getSalesSupport',
        type: 'GET',
        data: {
          type: 1
        }
      }).then(res => {
        if (res.data) {
          this.salesSupportList = res.data;
        }
      });
      this.$http({
        url: '/buz/userBase/okbao/getSalesSupport',
        type: 'GET',
        data: {
          type: 2
        }
      }).then(res => {
        if (res.data) {
          this.groupSalesSupportList = res.data;
        }
      });
    },
    // 导出
    exportExcel() {
      if (!this.$units.pointAction('offline_81_5_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (this.total == '0') {
        this.$notice.error('无可导出数据');
        return
      }
      let data = {
        type: 2,
        ...this.parameter(),
        owerTypes: [2, 3],
        sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : ''
      };
      this.$units.downloadFile('/buz/commissionLog/export', data, 'POST');
    },
    // 获取保司
    getBaosi() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        //赠险公司列表初始化
        this.companyList = res.data;
      });
    },
    // 产品
    queryProduct() {
      this.$http({
        url: '/buz/productBase/read/array',
        type: 'POST',
        data: {
          productCategory: 1
        }
      }).then(res => {
        this.productList = res.data;
      });
    },
    //险种分类
    getProductTheme() {
      let id = Object.keys(JSON.parse(localStorage.dic).GROUP_THEME_ID)[0];
      this.$http({
        url: '/buz/productThemeJoin/queryProductTheme',
        type: 'GET',
        data: {
          id
        }
      }).then(res => {
        this.productThemeList = treeFlatArr(this.dealTree1(res.data)).filter(item => item.level == 2);
      });
    },
    dealTree1(arr) {
      return arr.map(item => {
        return {
          ...item,
          value: item.themeId,
          label: item.name,
          title: item.name,
          expand: true,
          children: item.child && item.child.length > 0 ? this.dealTree1(item.child, item.name) : null
        };
      });
    },
    changeThemeIds(data) {
      // 1.当前选择的是父级，所有子集同步父级状态
      const cur = data[0]; //当前点击节点
      const ids = data[1]; //当前选中的所有id
      let isAdd = ids.includes(cur.value); //是否是新增勾选
      cur.children &&
        cur.children.forEach(item => {
          const index = ids.indexOf(item.value);
          if (isAdd && index == -1) {
            //新增未勾选的节点
            ids.push(item.value);
          } else if (!isAdd && index != -1) {
            //删除已勾选的节点
            ids.splice(index, 1);
          }
        });
      // 2.当前选择的是子级，处理父级
      if (cur.parentId != '0') {
        // 2.1 如果是新增勾选节点父级也新增勾选，父级如果已勾选不处理
        if (isAdd && !ids.includes(cur.parentId)) {
          ids.push(cur.parentId);
        }
        // 2.2 如果是取消勾选节点且所有同级都是取消状态时父级也取消
        if (!isAdd) {
          let isCancelAll = true; //是否是取消所有子集
          const parentData = this.productThemeJoinVOS.find(item => item.value == cur.parentId);
          parentData.children.forEach(item => {
            if (ids.includes(item.value)) {
              isCancelAll = false;
            }
          });
          if (isCancelAll) {
            const index = ids.indexOf(cur.parentId);
            if (index != -1) {
              ids.splice(index, 1);
            }
          }
        }
      }
      this.searchParams.themeIds = ids;
    },
    // 所属结算单
    getSettlementDocList() {
      this.$http({
        url: '/buz/userSalaryReport/read/list',
        type: 'POST',
        data: { pageNo: 1, pageSize: 9999 }
      }).then(res => {
        this.settlementDocList = res.data;
      });
    },
    // 所属结算报表
    getSettlementList() {
      this.$http({
        url: '/buz/userSettlementReport/read/list',
        type: 'POST',
        data: { pageNo: 1, pageSize: 9999 }
      }).then(res => {
        this.settlementList = res.data.filter(item => item.type == 3);
      });
    },
    // 获取当前机构业务员
    getUserList(keyword) {
      if (!keyword || keyword.includes('-')) {
        return;
      }
      const params = {
        userName: keyword
      };
      return this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    changeTimeNull(value, key) {
      this.searchParams[key] = '';
    },
    parameter() {
      let data = JSON.parse(JSON.stringify(this.searchParams));
      if (data.date && data.date[0]) {
        if (this.dateType == 1) {
          //投保日期
          data.holdTimeStart = data.date[0];
          data.holdTimeEnd = data.date[1];
        } else if (this.dateType == 2) {
          //承保日期
          data.insureTimeStart = data.date[0];
          data.insureTimeEnd = data.date[1];
        } else if (this.dateType == 3) {
          //生效日期
          data.effectTimeStart = data.date[0];
          data.effectTimeEnd = data.date[1];
        } else if (this.dateType == 4) {
          //退保日期
          data.refundTimeStart = data.date[0];
          data.refundTimeEnd = data.date[1];
        } else if (this.dateType == 5) {
          //支付日期
          data.payTimeStart = data.date[0];
          data.payTimeEnd = data.date[1];
        }
      }

      if (data.settlementReportNull && data.settlementReportNull.length) {
        data.settlementReportIdIsNull = '1';
        delete data.settlementReportId;
        delete data.settlementReportNull;
      } else {
        delete data.settlementReportNull;
      }

      // 结算周期
      if (data.settlementDate && data.settlementDate[0]) {
        data.settlementDateStart = data.settlementDate[0];
        data.settlementDateEnd = data.settlementDate[1];
      }
      if (data.settlementTimeNull && data.settlementTimeNull.length) {
        data.settlementDateIsNull = '1';
        delete data.settlementDateStart;
        delete data.settlementDateEnd;
        delete data.settlementTimeNull;
      } else {
        delete data.settlementTimeNull;
      }

      // 业务类别
      if (data.sellTypeStatusNull && data.sellTypeStatusNull.length) {
        data.sellTypeIsNull = '1';
        delete data.sellTypeStatusNull;
      } else if (data.sellType == '') {
        delete data.sellTypeStatusNull;
      } else {
        delete data.sellTypeStatusNull;
      }

      delete data.date;
      delete data.settlementDate;
      return data;
    },
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/commissionLog/queryLogPage',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: 2,
          ...this.parameter(),
          owerTypes: [2, 3],
          sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : ''
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 统计
    getStatistics() {
      this.$http({
        url: '/buz/commissionLog/statistics ',
        type: 'POST',
        data: {
          type: 2,
          ...this.parameter(),
          owerTypes: [2, 3],
          sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : ''
        }
      })
        .then(res => {
          this.statisticsData = res.data;
        })
    },
    // 扣款
    withholdingCommission(row) {
      if (!this.$units.pointAction('offline_81_5_2')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      let data = JSON.parse(JSON.stringify(row));
      data.commission = Number(data.commission).div(100);
      this.$refs.commissionModify.open(data, false);
    }
  }
};
</script>

<style lang="scss" scoped>
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);
  &.red {
    background: #e3461f;
  }
  &.orange {
    background: #ff9900 !important;
  }
}
.tools-box {
  display: flex;
  justify-content: space-between;
  .statistics-container {
    display: flex;
    margin: 10px 0;
    flex-wrap: wrap;
    .statistics-item {
      display: flex;
      margin-right: 20px;
      flex-wrap: nowrap;
      .dot {
        width: 4px;
        height: 4px;
        background: #236dff;
        align-self: center;
        margin-right: 7px;
      }
      .num {
        color: #3c464f;
      }
    }
  }
  button {
    margin-left: auto;
  }
}
.disabled-btn {
  cursor: no-drop;
  color: #c5c8ce;
}
.label {
  position: relative;
  .tip-icon {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .pop-tip {
    position: absolute;
    bottom: -40px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -0px;
    padding: 3px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      top: -4px;
      left: 29px;
      transform: rotateZ(135deg);
    }
  }
}
/deep/ .my-poptip {
  border: 1px solid red;
}
.settlement-status {
  display: flex;
  .tag-settled {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 2px;
    font-size: 13px;
    color: #e3461f;
    border: 1px solid #ffc1b2;
    background: #fff5f2;
  }
  .tag-be {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
    color: #35bf3f;
    border: 1px solid #abeaae;
    background: #f6fcf4;
  }
}
.release-status {
  display: flex;
  .tag-settled {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 2px;
    font-size: 13px;
    color: #e3461f;
    border: 1px solid #ffc1b2;
    background: #fff5f2;
  }
  .tag-be {
    width: 55px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
    color: #35bf3f;
    border: 1px solid #abeaae;
    background: #f6fcf4;
  }
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
</style>
